module.exports = window["wp"]["mediaUtils"];